import Export from './views/Export';

import ButtonTooltip from '../../ButtonTooltip';

import Icon from '@map/components/Icons';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';
import TabModal from 'views/MapView/components/TabModal';

/**
 * Função responsável por exportar o projeto atual.
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Setar o estado
 * @returns Um arquivo com as alterações, desenhos, camadas
 * do projeto atual, podendo ser usado mais tarde na importa-
 * ção do projeto.
 */
export const ExportProject = ({ mapContext, isActive, setIsActive }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const views = [
    {
      title: 'Exportar arquivo',
      Component: (
        <Export mapContext={mapContext} onClose={() => setModalOpen(false)} />
      ),
      valid: true,
    },
  ];

  return (
    <div style={{ display: 'flex' }}>
      <ButtonTooltip
        tooltip="Exportar Projeto"
        description="Exportar projeto atual."
        onClick={() => {
          setModalOpen(true);
          setIsActive();
        }}
        active={isActive}
      >
        <Icon
          i="map-toolbar-export"
          width="17"
          height="17"
          style={{ verticalAlign: 'middle' }}
        />
      </ButtonTooltip>
      <TabModal
        title="Exportar arquivo"
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setIsActive();
        }}
        views={views}
      />
    </div>
  );
};

ExportProject.properties = {
  id: 'CPN-TB-P-EXPORT_PROJECT',
  alias: 'Exportar projeto',
  description: 'Ferramenta para exportação do projeto em arquivo .gba',
};

export default ExportProject;
